import { render, staticRenderFns } from "./Storification.vue?vue&type=template&id=2be37e8d"
import script from "./Storification.vue?vue&type=script&lang=js"
export * from "./Storification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be37e8d')) {
      api.createRecord('2be37e8d', component.options)
    } else {
      api.reload('2be37e8d', component.options)
    }
    module.hot.accept("./Storification.vue?vue&type=template&id=2be37e8d", function () {
      api.rerender('2be37e8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Storification.vue"
export default component.exports